const Index = ({
	               onClick,
	               text,
	               start_icon,
	               color_type = "default",
	               end_icon,
	               disabled,
	               loading,
	               shimmer,
	               badge,
	               badge_type,
	               tooltip,
	               tooltip_placement = "top",
	               horizontal_tooltip_placement = "center",
	               component,
	               shimmer_style,
	               className,
	               options,
	               badge_pulse,
	               ...props
               }) => {

	// While loading the text is replaced by a spinner, which left the button without an accessible name (axe
	// `button-name`, chawk-bazar). The text stays the name through `aria-label`; an `aria-label` prop still wins.
	const loading_label = loading && (typeof text === "string" || typeof text === "number") ? String(text) : undefined;

	return (
		shimmer ?
			<div className={`loading-animation ${shimmer_style}`}/>
			:
			<button
				onClick={onClick}
				className={`${className ? className : ''} button-component ${options?.btn?.[color_type]}`}
				disabled={disabled || shimmer || loading}
				aria-busy={loading ? true : undefined}
				aria-label={loading_label}
				{...props}
			>
				{start_icon &&
					<span className="button-icon start-icon">
					{loading ?
						<span className="spinner"/>
						:
						start_icon}
				</span>
				}

				{text &&
					<span className={`button-text ${loading ? 'flex' : ''}`}>
						{(loading && !(start_icon || end_icon)) ?
							<span className="spinner"/> : text}
					</span>
				}

				{end_icon &&
					<span className="button-icon end-icon">
					{loading ?
						<span className="spinner"/>
						:
						end_icon}
				</span>
				}

				{badge && <span className={`button-badge ${options?.badge?.[badge_type]}`}>{badge}</span>}

				{badge_pulse && <span className={`button-badge-pulse`}/>}

				{tooltip &&
					<span className={`tooltip 
					${tooltip_placement === 'top' ? 'top-tooltip' : 'bottom-tooltip'}
					${horizontal_tooltip_placement === 'center' && 'horizontal-center-tooltip-placement'}
					${horizontal_tooltip_placement === 'right' && 'horizontal-right-tooltip-placement'}
					${horizontal_tooltip_placement === 'left' && 'horizontal-left-tooltip-placement'}
					`}>
						{tooltip}
					</span>
				}

				{((!start_icon || !end_icon || !text) && component) && (loading ?
					<span className="spinner"/> : component)}
			</button>
	)
}

export default Index